import { Controller } from 'stimulus'

export default class extends Controller {
    static targets = []

    connect() {
        this.card = jQuery(this.element)
    }

    toggle() {
        this.card.toggleClass('open')
        this.card.find('.card-body').slideToggle(100)

        // Reconnect selectpickers
        const selectPickers = this.element.querySelectorAll('[data-controller="selectpicker"]')
        selectPickers.forEach(picker => {
            this.application.getControllerForElementAndIdentifier(picker, 'selectpicker').connect()
        }, this)
    }
}
